import React from 'react';
import {FormattedMessage} from 'react-intl';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {CheckCircleIcon} from '@amblique/king-living/app/components/icons';

/**
 * WhySignUp Component
 *
 * Displays the benefits of signing up to King Living account.
 * Shown on the login and registration pages.
 */
const WhySignUp = (props) => {
  const styles = useMultiStyleConfig('WhySignUp', {});

  const benefits = [
    {
      id: 'order_history',
      message: (
        <FormattedMessage
          defaultMessage="View your order history and track deliveries"
          id="why_signup.benefit.order_history"
        />
      ),
    },
    {
      id: 'faster_checkout',
      message: (
        <FormattedMessage
          defaultMessage="Faster checkout with saved details and addresses"
          id="why_signup.benefit.faster_checkout"
        />
      ),
    },
  ];

  return (
    <Box {...styles.container} {...props}>
      <Text {...styles.title}>
        <FormattedMessage
          defaultMessage="Why sign up to King Living?"
          id="why_signup.title"
        />
      </Text>
      <Box {...styles.checkCircleContainer}>
        {benefits.map((benefit) => (
          <Box key={benefit.id} {...styles.checkCircleItem}>
            <CheckCircleIcon {...styles.checkCircleIcon} />
            <Text {...styles.description}>{benefit.message}</Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default WhySignUp;
